import { TooltipContent } from "../../InfoTooltip/TooltipModules";
import { TooltipHeader } from "../../InfoTooltip/TooltipModules";
import { InfoTooltip } from "../../InfoTooltip/InfoTooltip";
import React, { Fragment } from "react";

export const HeatmapTooltip = () => {
  const content = (
    <Fragment>
      <TooltipContent>
        Each square on the heatmap represents a single day. It works just like a
        calendar. The darker the colour of the square, the more energy was
        generated or consumed on the day. Clicking a square will refresh the
        energy graph and the energy break down bar above.
      </TooltipContent>
      <TooltipHeader>Check it out!</TooltipHeader>
      <TooltipContent>
        We can change what type of heatmap we want to view. Let's try it. Click
        the drop down box in the top left and select 'Grid consumed'. Ta-da! We
        have a brand new heatmap to explore.
      </TooltipContent>
    </Fragment>
  );

  return <InfoTooltip content={content} />;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/tooltips/HeatmapTooltip.js